import { render } from "./AliasesSearchToolbar.vue?vue&type=template&id=4524b310&ts=true"
import script from "./AliasesSearchToolbar.vue?vue&type=script&lang=ts"
export * from "./AliasesSearchToolbar.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Data\\TCF\\ABBp_PIS\\6.12\\PisNextGenExtTrain-PisApp_6_12_0\\PisNextGenExtTrain\\PisNextGen\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__